import React, { useMemo } from "react";

const DateIcon = () => {
  const svgContent = useMemo(() => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 20.314 20.313"
      >
        <path
          id="calendar-svgrepo-com"
          d="M0,10V24.875a1.527,1.527,0,0,0,1.531,1.5h17.25a1.527,1.527,0,0,0,1.531-1.5V10a1.527,1.527,0,0,0-1.531-1.5h-1.75V8.344A2.431,2.431,0,0,0,16.5,6.781a2.637,2.637,0,0,0-1.938-.719,2.534,2.534,0,0,0-1.938.719,2.3,2.3,0,0,0-.563,1.563V8.5H8.248V8.344a2.431,2.431,0,0,0-.531-1.563,2.664,2.664,0,0,0-1.969-.719,2.507,2.507,0,0,0-1.906.719,2.3,2.3,0,0,0-.563,1.563V8.5H1.529A1.527,1.527,0,0,0,0,10ZM2.063,24.344v-3.25H5.719v3.25Zm0-3.75v-3.25H5.719v3.25Zm0-3.75V13.563H5.719v3.281Zm2.718-5.875V8.344c0-.5.313-.75.969-.75.688,0,1,.25,1,.75v2.625c0,.5-.313.75-1,.75C5.094,11.719,4.781,11.469,4.781,10.969ZM6.219,24.344v-3.25H9.907v3.25Zm0-3.75v-3.25H9.907v3.25Zm0-3.75V13.563H9.907v3.281Zm4.187,7.5v-3.25h3.688v3.25Zm0-3.75v-3.25h3.688v3.25Zm0-3.75V13.563h3.688v3.281Zm4.188,7.5v-3.25H18.25v3.25Zm0-3.75v-3.25H18.25v3.25Zm0-3.75V13.563H18.25v3.281Zm-1.031-5.875V8.344c0-.5.313-.75,1-.75.625,0,.969.25.969.75v2.625c0,.5-.313.75-.969.75C13.875,11.719,13.563,11.469,13.563,10.969Z"
          transform="translate(0.002 -6.062)"
          fill="#7a8790"
        />
      </svg>
    );
  }, []);

  return svgContent;
};

export default DateIcon;



// WEBPACK FOOTER //
// ./src/assets/DateIcon.jsx